import { render, staticRenderFns } from "./ImotView.vue?vue&type=template&id=40758da3"
import script from "./ImotView.vue?vue&type=script&lang=js"
export * from "./ImotView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports